import { TextField } from "@mui/material";
import React from "react";
import { Spinner } from "react-bootstrap";
import { useSelectUser } from "./Hook";
const SelectUser = ({ form, setform }) => {
  const { loading, checkMobile, reserve, renderState } = useSelectUser(
    form,
    setform
  );
  const renderComponent = () => {
    if (!form.result) {
      return;
    }
    switch (form.result.user) {
      case "no":
        return;
      case true:
        return (
          <div className="mt-4 ">
            <div className="form-group">
              <TextField
                fullWidth
                label="نام و نام خانوادگی "
                size="small"
                value={form.result.fullname}
                disabled
              />
            </div>
            <div className="form-group">
              <TextField
                fullWidth
                label="کد ملی"
                size="small"
                type="number"
                value={
                  form.result.national_code == false
                    ? ""
                    : form.result.national_code
                }
                disabled={renderState(form.result.national_code)}
                onChange={({ target: { value } }) => {
                  setform({
                    ...form,
                    result: { ...form.result, national_code: value },
                  });
                }}
              />
            </div>
            <div className="form-group">
              <TextField
                fullWidth
                label="شماره"
                size="small"
                type="number"
                value={form.result.mobile}
                disabled={form.result.mobile}
              />
            </div>
          </div>
        );
      case false:
        return (
          <div>
            <div className="form-group ">
              <label htmlFor="exampleInputEmail1">نام</label>
              <input
                className="form-control"
                onChange={({ target: { value } }) => {
                  setform({ ...form, fullname: value });
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1">کد ملی</label>
              <input
                type="number"
                className="form-control"
                onChange={({ target: { value } }) => {
                  setform({ ...form, national_code: value });
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1">شماره</label>
              <input
                type="number"
                className="form-control"
                value={form.mobile}
                disabled
              />
            </div>
          </div>
        );
      default:
        break;
    }
    return;
  };
  return (
    <div className="container">
      <div className="row justify-content-center mb-4">
        <div className="col-md-6">
          <h6 className="text-center" style={{ fontSize: "20px", margin: 0 }}>
            مدیر مجموعه عزیز
          </h6>
          <p className="text-center" style={{ fontSize: "16px", margin: "0" }}>
            برای رزرو قراردادی ، شماره موبایل کاربر مورد نظر را وارد کنید
          </p>
        </div>
      </div>{" "}
      <div className="row mt-3 justify-content-center ">
        <div className="col-md-6">
          <div className="form-group d-flex">
            <TextField
              fullWidth
              label={"شماره موبایل"}
              size="small"
              onChange={({ target: { value } }) => {
                setform({ ...form, result: { user: "no" }, mobile: value });
              }}
              type="number"
              length="11"
            />
            <button onClick={checkMobile} className="btn btn-primary mr-2">
              {loading.btn ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "ثبت"
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-6">{renderComponent()}</div>
      </div>
    </div>
  );
};
export default SelectUser;
